// extracted by mini-css-extract-plugin
module.exports = {"metricsRow":"Metrics_metricsRow__fyhBG","metric":"Metrics_metric__cMuBM","name":"Metrics_name__RPl_8","value":"Metrics_value__kMIoc","unit":"Metrics_unit__hcQs4"};